module.exports = __webpack_public_path__ + "img/img-ok.32d0ebad.png";